module.exports = __webpack_public_path__ + "img/glassquality_7.dd0787c1.png";